function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#1d1d1d",
  d: "M15.088-4.72l3.579 3.579L16.858.667 13.28-2.912v-.961l-.339-.339a7.642 7.642 0 0 1-5.086 1.865 7.576 7.576 0 0 1-5.566-2.289A7.543 7.543 0 0 1 0-10.174a7.543 7.543 0 0 1 2.289-5.538A7.543 7.543 0 0 1 7.826-18a7.543 7.543 0 0 1 5.538 2.289 7.576 7.576 0 0 1 2.289 5.566 7.642 7.642 0 0 1-1.865 5.085l.339.339zM4.012-6.3a5.232 5.232 0 0 0 3.843 1.58A5.232 5.232 0 0 0 11.7-6.3a5.232 5.232 0 0 0 1.582-3.843 5.232 5.232 0 0 0-1.582-3.845 5.232 5.232 0 0 0-3.845-1.582 5.232 5.232 0 0 0-3.843 1.582 5.232 5.232 0 0 0-1.582 3.843A5.232 5.232 0 0 0 4.012-6.3z",
  transform: "translate(4.667 22.667)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0H28V28H0z"
});

function SvgIconSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/iconSearch.079386a3.svg";
export { ForwardRef as ReactComponent };